<template>
  <div class="contant">
    <Echart :options="options" id="rightBottom" height="220px" width="100%" :style="{ opacity: !isHaveData ? 0 : 1 }"></Echart>
    <div v-if="!isHaveData" class="no-data">暂无数据</div>
  </div>
</template>

<script>
import Echart from "@/components/echart";
export default {
  name: "right-bottom",
  data() {
    return {
      options: {},
      isHaveData: true,
    };
  },
  components: {
    Echart,
  },
  props: {
    echartData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    echartData: {
      handler(newData) {
        if (newData.xLineList.length > 0) {
          this.isHaveData = true;
        } else {
          this.isHaveData = false;
        }
        this.options = {
          title: {
            text: "",
          },
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC",
              },
            },
            textStyle: {
              color: "#fff", //设置文字颜色
            },
          },
          legend: {
            data: ["转入数", "转回数", "停租数"],
            textStyle: {
              color: "#B4B4B4",
            },
            // top: "0%",
            show: true,
            x: "center",
            bottom: "-2px",
          },
          grid: {
            x: "70px",
            width: "85%",
            height: "70%",
            y: "28px",
          },
          xAxis: {
            data: this.echartData.xLineList,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisLabel: {
              formatter: "{value} ",
              textStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: [
            {
              // name: "件",
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4",
                },
              },

              splitLine: {
                //网格线
                show: true,
                lineStyle: {
                  color: "#B4B4B4",
                },
              },
              axisLabel: {
                formatter: "{value} ",
                textStyle: {
                  color: "#fff",
                },
              },
            },
          ],
          series: [
            {
              name: "转入数",
              type: "line",
              smooth: true,
              animation: true,
              showAllSymbol: true,
              //   axisTick: {
              //     lineStyle,
              //   },
              symbol: "emptyCircle",
              symbolSize: 8,

              itemStyle: {
                normal: {
                  color: "#21f8f4",
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "#fff",
                      fontSize: 12,
                    },
                  },
                },
              },
              data: this.echartData.deliverInList,
            },
            {
              name: "转回数",
              type: "line",
              smooth: true,
              animation: true,
              showAllSymbol: true,
              //   axisTick: {
              //     lineStyle,
              //   },
              symbol: "emptyCircle",
              symbolSize: 8,

              itemStyle: {
                normal: {
                  color: "#ffee6f",
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "#fff",
                      fontSize: 12,
                    },
                  },
                },
              },
              data: this.echartData.deliverOutList,
            },
            {
              name: "停租数",
              type: "line",
              smooth: true,
              animation: true,
              showAllSymbol: true,
              //   axisTick: {
              //     lineStyle,
              //   },
              symbol: "emptyCircle",
              symbolSize: 8,

              itemStyle: {
                normal: {
                  color: "#f13318",
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "#fff",
                      fontSize: 12,
                    },
                  },
                },
              },
              data: this.echartData.reDataList,
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.contant {
  position: relative;

  .no-data {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #7e7d85;
    background: #10083c;
  }
}
</style>
